import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import SubscriptionViewModel from "@/models/SubscriptionViewModel";
export default function () {
    const getSubscription = async (): Promise<SubscriptionViewModel> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.get(`/api/subscription`)
                .then((result: AxiosResponse<SubscriptionViewModel>) => {
                    if (result.status === 200) {
                        resolve(result.data);
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };
    return {
        getSubscription,
    };
}
